import PropTypes from "prop-types";
import React from "react";
import SVG from "theme/components/icons/base/SVG";

const DownloadIcon = ({ color, fill, ...props }) => (
    <SVG fill={fill} viewBox="0 0 23 24" {...props}>
        <rect
            width="51"
            height="51"
            x=".5"
            y="51.94"
            stroke={color}
            strokeOpacity=".7"
            rx="25.5"
            transform="rotate(-90 .5 51.94)"
        />
        <path stroke={color} d="M20 34.94h12" />
        <path
            fill={color}
            fillRule="evenodd"
            d="m20 22.263 5.5 6.5.382.451.381-.451 5.5-6.5-.763-.646-4.618 5.458V17.44h-1v9.635l-4.619-5.458-.763.646Z"
            clipRule="evenodd"
        />
    </SVG>
);

DownloadIcon.propTypes = {
    color: PropTypes.string,
    fill: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    viewBox: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

DownloadIcon.defaultProps = {
    color: "currentColor",
    fill: "none",
    height: "53px",
    viewBox: "0 0 52 53",
    width: "52px",
};

export default DownloadIcon;
